/**
 * Check if integration data has customized Thank You Page behavior.
 *
 * This is used to decide whether to enable Guest Checkout, which is problematic with other Verticals. Digital benefits
 * can be redeemed only for logged in members, but with Guest Checkout an anonymous visitor might end up at the end of
 * the funnel and be asked to pay again.
 *
 * As a workaround we usually choose to disable Guest Checkout if flow is customized to prevent confusion.
 */
export function isCustomPurchaseFlow(integrationData) {
  return Boolean(integrationData.verticalStatusContent) || Boolean(integrationData.navigateToSectionProps) || Boolean(integrationData.navigateToPageProps);
}
//# sourceMappingURL=is-custom-purchase-flow.js.map